import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import I18N from 'src/services/I18NService';
import { Button, message } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { IPriceChangeData, EnumAdjustStatus } from 'src/services/PriceChangeService';
import { RouterConfig } from 'src/routers/urlConfig';
import CommonTable from 'src/components/common/CommonTable';
import { ICommonTable } from '../../common/CommonTable';
import PriceChangeService from 'src/services/PriceChangeService';
import * as moment from 'moment';
import { IPageQuery } from 'src/entity/SearchEntity';

interface IPriceChangeRecordPageProps extends RouteComponentProps {}

interface IPriceChangeRecordPageState extends ICommonTable<IPriceChangeData> {
  /** 查询条件 */
  query: IPageQuery;
}

class PriceChangeRecordPage extends React.Component<IPriceChangeRecordPageProps, IPriceChangeRecordPageState> {
  constructor(props: IPriceChangeRecordPageProps) {
    super(props);

    const columns: Array<ColumnProps<IPriceChangeData>> = [
      {
        title: I18N.get('med_price_change_application_date'),
        key: 'application_date',
        dataIndex: 'application_date',
        render: (text: any, record: IPriceChangeData, index: number): React.ReactNode => {
          return !!record.application_date ? moment(record.application_date).format('YYYY-MM-DD HH:mm:ss') : '';
        },
      },
      {
        title: I18N.get('med_price_change_content'),
        key: 'seller_user_name',
        dataIndex: 'seller_user_name',
        render: (text: any, record: IPriceChangeData, index: number): React.ReactNode => {
          return `${record.seller_user_name}${I18N.get('med_price_change_content_desc')}`;
        },
      },
      {
        title: I18N.get('med_price_change_applicant'),
        key: 'applicant_name',
        dataIndex: 'applicant_name',
      },
      // {
      //   title: I18N.get('med_price_change_approver'),
      //   key: 'approve_name',
      //   dataIndex: 'approve_name',
      // },
      {
        title: I18N.get('common_status'),
        key: 'status',
        dataIndex: 'status',
        render: (text: any, record: IPriceChangeData, index: number): React.ReactNode => {
          const desc = PriceChangeService.getAdjustStatusDesc(record.status);
          return record.status === EnumAdjustStatus.APPROVED ? desc : <span style={{ color: '#00CB4A' }}>{desc}</span>;
        },
      },
      {
        title: I18N.get('common_operation'),
        dataIndex: 'operation',
        key: 'operation',
        render: (text: any, record: IPriceChangeData, index: number): React.ReactNode => {
          return (
            <div>
              <a onClick={() => this.showDetail(record)}>{I18N.get('common_detail')}</a>
            </div>
          );
        },
      },
    ];

    this.state = {
      rowKey: 'uuid',
      loadingTable: false,
      columns,
      dataSource: [],
      query: {
        offset: 0,
        limit: 10,
      },
    } as IPriceChangeRecordPageState;
  }

  async componentDidMount() {
    await this.handleSearch();
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  goback = () => {
    this.props.history.goBack();
  };

  showDetail = (record: IPriceChangeData) => {
    if (!record) {
      return;
    }

    this.props.history.push(`${RouterConfig.Urls.price}/change/${record.uuid}`);
  };

  handleSearch = async (offset: number = 0, limit: number = 10) => {
    if (this.state.loadingTable) {
      return;
    }
    try {
      this.setState({
        loadingTable: true,
      });
      const res = await PriceChangeService.getPriceChangeDataList(offset, limit);
      if (!!res) {
        this.setState({
          dataSource: res.results,
          total: res.count,
          loadingTable: false,
          query: {
            offset,
            limit,
          },
        });
      }
    } catch (error) {
      this.setState({
        loadingTable: false,
      });
      if (!!error.response) {
        message.error(JSON.stringify(error.response.data));
      } else {
        message.error(I18N.get('err_search_failure'));
      }
    }
  };

  render() {
    return (
      <div>
        <div className="price-change-page">
          <div style={{ color: '#1FB8CD' }}>{I18N.get('med_price_change_record')}</div>
          <div>
            <Button type="primary" onClick={this.goback}>
              {I18N.get('common_back')}
            </Button>
          </div>
        </div>

        <CommonTable
          rowKey={this.state.rowKey}
          showPagination={(this.state.total || 0) > 0}
          columns={this.state.columns}
          loadingTable={this.state.loadingTable}
          dataSource={this.state.dataSource}
          total={this.state.total}
          offset={this.state.query.offset}
          limit={this.state.query.limit}
          callback={this.handleSearch}
        />
        {/* 
<CommonTable
          rowKey={this.state.rowKey}
          showPagination={(this.state.total || 0) > 0}
          columns={this.state.columns}
          loadingTable={this.state.loadingTable}
          dataSource={this.state.dataSource}
          total={this.state.total}
          offset={this.state.query.offset}
          limit={this.state.query.limit}
          callback={this.handleSearch}
        /> */}
      </div>
    );
  }
}

export default PriceChangeRecordPage;



// WEBPACK FOOTER //
// ./src/components/views/Price/PriceChangeRecordListPage.tsx